// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"c6-z"};